import React from 'react';
import { MODALS } from '../../../../config/images';
const ModalRefused = ({
  showModalRefused,
  closeModal,
  accept,
  pos,
  oc
}) => {
  if (!showModalRefused) return null;

const getMessage = () => {
  if (pos) {
    return (
      /*
      <div>
        <p>¿Está seguro de rechazar la(s) posición(es):</p>
        <div style={{whiteSpace: 'pre-line', marginTop: '10px'}}>
          {pos}
        </div>
        <p>?</p>
      </div>*/
        <p>¿Está seguro de rechazar la(s) posición(es)?</p>

    );
  } 
  return '¿Está seguro de rechazar los elementos seleccionados?';
};

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
      <div className="lg:w-[23.33%] w-[85%] h-auto bg-white rounded-3xl shadow-lg flex flex-col pb-4  ">
        <div className='flex justify-end'>
          <button
            onClick={closeModal}
            className="px-4 py-2 rounded-md"
          >
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>
        </div>
        <div className='flex flex-col items-center justify-center gap-3 p-4 px-8'>
            <img src={MODALS.WARNING} alt="warning"/>
            <div className='flex flex-col gap-4'>
              <p className="lg:text-[1vw] text-center font-itcdemi">
                {getMessage()}
              </p>
              <button
              onClick={accept}
               className='text-sm underline font-itcbook text-blue '>
                Aceptar
              </button>
            </div>
        </div>
      </div>
    </div>
  );
};
export default ModalRefused;
